import { render, staticRenderFns } from "./PosCounterHeader.vue?vue&type=template&id=2a67b973&scoped=true"
import script from "./PosCounterHeader.vue?vue&type=script&lang=js"
export * from "./PosCounterHeader.vue?vue&type=script&lang=js"
import style0 from "./PosCounterHeader.vue?vue&type=style&index=0&id=2a67b973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67b973",
  null
  
)

export default component.exports